/** Ambient atmosphere: drifting color blobs + faint dot grid at top */
export default function Orbs() {
  return (
    <>
      <div className="ambient" aria-hidden>
        <div className="blob blob-green" />
        <div className="blob blob-lilac" />
        <div className="blob blob-peach" />
      </div>
      <div className="dot-grid" aria-hidden />
    </>
  );
}
